export class NaviRequestError extends Error {

    public responce:Response;

    //Responceをエラーオブジェクトに付与
    constructor(message:string,responce:Response) {
        super(message);
        this.responce = responce;
    }

}